import React from 'react'

import Svg from './svg'


export default function Trashcan2Icon({width, height, color, color2 = '--accent-color', ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color
    color2 = getComputedStyle(document.documentElement)
        .getPropertyValue(color2) || color2

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="trashcan2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M21.0618938,21 L15,21 L15,10.1111111 L15.1811534,10.1111111 C15.7524662,8.31560738 17.60964,7 19.8125,7 L35.1761197,7 C35.4967008,4.643657 36.2207072,3 37.0625,3 L62.9375,3 C63.7792928,3 64.5032992,4.643657 64.8238803,7 L80.1875,7 C82.39036,7 84.2475338,8.31560738 84.8188466,10.1111111 L85,10.1111111 L85,21 L78.9381062,21 C78.9789567,21.3275942 79,21.6613397 79,22 L79,89 C79,93.418278 75.418278,97 71,97 L29,97 C24.581722,97 21,93.418278 21,89 L21,22 C21,21.6613397 21.0210433,21.3275942 21.0618938,21 L21.0618938,21 Z" id="Shape" fill={color}></path>
            <polygon id="Path" fill={color2} points="48 25 48 83 52 83 52 25"></polygon>
            <polygon id="Path" fill={color2} points="30 25 30 83 34 83 34 25"></polygon>
            <polygon id="Path" fill={color2} points="66 25 66 83 70 83 70 25"></polygon>
        </g>
    </Svg>
}
